import { mix } from "polished";
import { MdxTemplateContentRgbColor } from "@maven-rest/docs/Template.type";

export const colorPrimary = "#259ac5";
export const colorPrimaryText = "#ffffff";
export const appColorDanger = "#e46619";
export const appColorWarning = `${mix(0, "orange")(appColorDanger)}`;
export const colorActiveTableCell: MdxTemplateContentRgbColor = [217, 217, 217];

export const appContentBoxShadow = "0 0.2rem 0.3rem rgba(0, 0, 0, 0.03)";

export const colorCrossReference = "#2eabd8";
